module.exports = __webpack_public_path__ + "img/big.9c9bae20.jpg";